import { section } from '@/neon';
import mobileCarousel from '@/lib/mobile-carousel';

const sel = {
  slider: '[data-slider]',
};

section('blog-posts', {
  onLoad() {
    const carousel = this.container.querySelector(sel.slider);
    this.mobileCarousel = mobileCarousel(carousel);
  },

  onUnload() {
    this.mobileCarousel.destroy();
  },
});
